module.exports = __webpack_public_path__ + "static/img/en.06553d4a.png";